module.exports = __webpack_public_path__ + "img/hr-heated-corner-up-right-2.4d55179c.png";